/**
 * Promotions hub data source: `ers` (legacy) or `payload` (pg-payload-cms).
 * @returns {'ers' | 'payload'}
 */
export function getPromotionsSource() {
  const raw = process.env.REACT_APP_PROMOTIONS_SOURCE || "ers";
  const source = raw.split("#")[0].trim().toLowerCase();
  return source === "payload" ? "payload" : "ers";
}

export function isPayloadPromotionsSource() {
  return getPromotionsSource() === "payload";
}
